import { createFileRoute } from '@tanstack/react-router';
import SecurityGroupsPage from '@features/admin/security-groups/SecurityGroupsPage.tsx';
import { useCreateAdminSecurityGroupStore } from '@features/admin/security-groups/useAdminSecurityGroupStore.ts';

export const Route = createFileRoute('/admin/security-groups')({
  component: RouteComponent,
  beforeLoad: () => {
    useCreateAdminSecurityGroupStore.getState().loadSecurityGroups();
  },
});

function RouteComponent() {
  return <SecurityGroupsPage />;
}
